<template>
  <div>
    <p class="text-2xl mb-6">Gerencia</p>
    <div>
      <v-row>
        <v-col cols="12" md="5" >
          <dos-fechas
            :fechas="[fecha.desde,  fecha.hasta]"
            @getFechas="getFechas" 
          ></dos-fechas>
        
        </v-col>
        <v-col cols="12" md="5" >
          <select-grupo-negocio
            :SelectDefault="-1"
            :todos="true"
            @getSelect="getGrupoNegocio"
            :dense="true"
            :outlined="true"
          ></select-grupo-negocio>
        </v-col>
        <v-col  cols="2" class="text-center" >
          <v-btn @click="buscar()" class="primary" small>Buscar</v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12"  >
          <v-card>
            <grafica-cierre-dia :fechaIni="fecha" :filtrosShow="false" ref="graficaCierreDiaRef"></grafica-cierre-dia>
          </v-card>
        </v-col>
        <v-col cols="12" lg="6">
          <v-card>
            <grafica-productos-mas-vendidos :fechaIni="fecha" :filtrosShow="false" ref="graficaProductoMasVendidoRef">
            </grafica-productos-mas-vendidos>
          </v-card>
        </v-col>

        <v-col cols="12" lg="6">
          <v-card>
            <grafica-ventas-mesoneros :fechaIni="fecha" :filtrosShow="false" ref="graficaVentasMesoneroRef">
            </grafica-ventas-mesoneros>
          </v-card>
        </v-col>
        <v-col cols="12"  >
          <v-card>
            <grafica-cierre-puestos :fechaIni="fecha" :filtrosShow="false" ref="graficaCierrePuestoRef">
            </grafica-cierre-puestos>
          </v-card>
        </v-col>
        <v-col cols="12" lg="8">
          <v-card>
            <grafica-puesto-mas-vende :fechaIni="fecha" :filtrosShow="false" ref="graficaPuestoMasVendeRef">
            </grafica-puesto-mas-vende>
          </v-card>
        </v-col>
        <v-col cols="12" lg="4">
          <v-card>
            <grafica-radar-ventas-dias-semana
              :fechaIni="fecha"
              :filtrosShow="false"
              ref="graficaRadarVentasDiasSemanaRef"
            ></grafica-radar-ventas-dias-semana>
          </v-card>
        </v-col>

        <v-col cols="12" lg="8">
          <v-card>
            <GraficaVentasDiasSemanaoOrdenado
              :fechaIni="fecha"
              :filtrosShow="false"
              ref="graficaVentasDiasSemanaOrdenadoRef"
            ></GraficaVentasDiasSemanaoOrdenado>
          </v-card>
        </v-col>

        <v-col cols="12" lg="4">
          <v-card>
            <GraficaPuestoTipoMasVende :fechaIni="fecha" :filtrosShow="false" ref="graficaPuestoTipoMasVendeRef">
            </GraficaPuestoTipoMasVende>
          </v-card>
        </v-col>

        <v-col cols="12">
          <v-card>
            <GraficaMapaVentasPorMesas :fechaIni="fecha" :filtrosShow="false" ref="graficaMapaVentasPorMesasref">
            </GraficaMapaVentasPorMesas>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
  
<script>
// eslint-disable-next-line object-curly-newline
import { mdiPoll, mdiLabelVariantOutline, mdiCurrencyUsd, mdiHelpCircleOutline } from '@mdi/js'
import { onBeforeMount, ref } from '@vue/composition-api'
import MaestroService from '@/api/servicios/MaestroService'
import GraficaCierrePuestos from './componentes/GraficaCierrePuestos.vue'
import GraficaCierreDia from './componentes/GraficaCierreDia.vue'
import GraficaProductosMasVendidos from './componentes/GraficaProductosMasVendidos.vue'
import GraficaVentasMesoneros from './componentes/GraficaVentasMesoneros.vue'
import DosFechas from '@/components/DosFechas.vue'
import moment from 'moment'
import FuncionesGenerales from '@/funciones/funciones'
import GraficaPuestoMasVende from './componentes/GraficaPuestoMasVende.vue'
import GraficaRadarVentasDiasSemana from './componentes/GraficaRadarVentasDiasSemana.vue'
import GraficaPuestoTipoMasVende from './componentes/GraficaPuestoTipoMasVende.vue'
import GraficaVentasDiasSemanaoOrdenado from './componentes/GraficaVentasDiasSemanaoOrdenado.vue'
import GraficaMapaVentasPorMesas from './componentes/GraficaMapaVentasPorMesas.vue'
import SelectGrupoNegocio from '@/components/SelectGrupoNegocio.vue'
// demos

export default {
  components: {
    GraficaCierrePuestos,
    GraficaCierreDia,
    GraficaProductosMasVendidos,
    GraficaVentasMesoneros,
    DosFechas,
    GraficaPuestoMasVende,
    GraficaRadarVentasDiasSemana,
    GraficaVentasDiasSemanaoOrdenado,
    GraficaPuestoTipoMasVende,
    GraficaMapaVentasPorMesas,
    SelectGrupoNegocio,
  },
  setup() {
    const fecha = ref({
      desde: moment().startOf('month').format('YYYY-MM-DD'),
      hasta: moment().endOf('month').format('YYYY-MM-DD'),
    })
    const grupoNegocio = ref(-1)
    const graficaCierreDiaRef = ref(null)
    const graficaCierrePuestoRef = ref(null)
    const graficaProductoMasVendidoRef = ref(null)
    const graficaVentasMesoneroRef = ref(null)
    const graficaPuestoMasVendeRef = ref(null)
    const graficaRadarVentasDiasSemanaRef = ref(null)
    const graficaVentasDiasSemanaOrdenadoRef = ref(null)
    const graficaPuestoTipoMasVendeRef = ref(null)
    const graficaMapaVentasPorMesasref = ref(null)

    const getGrupoNegocio = datox => {
      if (datox != undefined) {
        grupoNegocio.value = datox.id
      }
    }

    const getFechas = dato => {
      fecha.value.desde = dato.desde
      fecha.value.hasta = dato.hasta
    }

    const buscar = () => {
      const dato = {
        desde: fecha.value.desde,
        hasta: fecha.value.hasta,
        grupo_negocio: grupoNegocio.value,
      }

      graficaProductoMasVendidoRef.value.getFechas(dato)
      graficaCierreDiaRef.value.getFechas(dato)
      graficaCierrePuestoRef.value.getFechas(dato)
      graficaVentasMesoneroRef.value.getFechas(dato)
      graficaPuestoMasVendeRef.value.getFechas(dato)
      graficaRadarVentasDiasSemanaRef.value.getFechas(dato)
      graficaVentasDiasSemanaOrdenadoRef.value.getFechas(dato)
      graficaPuestoTipoMasVendeRef.value.getFechas(dato)
      graficaMapaVentasPorMesasref.value.getFechas(dato)
    }

    onBeforeMount(() => {})

    return {
      FuncionesGenerales,
      graficaCierreDiaRef,
      graficaCierrePuestoRef,
      graficaProductoMasVendidoRef,
      graficaVentasMesoneroRef,
      graficaPuestoMasVendeRef,
      graficaRadarVentasDiasSemanaRef,
      graficaVentasDiasSemanaOrdenadoRef,
      graficaPuestoTipoMasVendeRef,
      graficaMapaVentasPorMesasref,
      getFechas,
      fecha,
      buscar,
      getGrupoNegocio,
      grupoNegocio,
    
    }
  },
}
</script>
  